/** Geolokalisierung Koordinaten */

/** Koordinaten */
export class Coordinates {

  private _longitude: number;
  private _latitude: number;
  private _success: boolean;
  private _accuracy: number;

  constructor(sucess: boolean = false, longitude: number = 0, latitude: number = 0, accuracy: number = 0) {
    this.setLatitude(latitude);
    this.setLongitude(longitude);
    this.setSuccess(sucess);
    this.setAccuracy(accuracy);
  }

  /** Längengrad */
  public get longitude(): number {
    return this._longitude;
  }
  private setLongitude(value: number) {
    this._longitude = value;
  }

  /** Breitengrad */
  public get latitude(): number {
    return this._latitude;
  }
  private setLatitude(value: number) {
    this._latitude = value;
  }

  /** Gibt an, ob die Koordinaten erfolgreich gelesen werden konnten */
  public get success(): boolean {
    return this._success;
  }
  private setSuccess(value: boolean) {
    this._success = value;
  }

  /** Genauigkeit */
  public get accuracy(): number {
    return this._accuracy;
  }
  private setAccuracy(value: number) {
    this._accuracy = value;
  }
}
